var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-notifications"},[_c('NotificationsContent',{attrs:{"in-modal":_vm.$route.query.modal}}),_c('ModalConfirmDelete'),_c('ModalTurnOff')],1)}
var staticRenderFns = []

export { render, staticRenderFns }